import { createContext, FC, useMemo, useState } from 'react'

const initialState: {
  selected: string[]
  toggleSelected(ids: string[]): void
} = {
  selected: ['cadastralPlots', 'taxonomicPlots'],
  toggleSelected: () => {},
}

const Context = createContext(initialState)
export default Context

export const LayersContextProvider: FC = ({ children }) => {
  const [state, setState] = useState(initialState)
  const value = useMemo(() => {
    const toggleSelected = (values: string[]) => {
      const { selected } = state
      const newSelected = selected.some((s) => values.includes(s))
        ? selected.filter((v) => !values.includes(v))
        : [...selected, ...values]

      setState({ ...state, selected: newSelected })
    }

    return { ...state, toggleSelected }
  }, [state])

  return <Context.Provider value={value}>{children}</Context.Provider>
}
